import moment from 'moment';
import calendarTemplate from './calendar-template.html';
import R from 'ramda';

export default function calendarAttendance() {

    return {
        restrict: "E",
        template: calendarTemplate,
        scope: {
            selected: "=",
            filleddates: "=",
            showdots: "="
        },
        link: function(scope) {
            scope.$watch('filleddates', function(){
                scope.selectedFormattedDate = scope.selected;
                scope.momentSelected = moment(scope.selected);
                scope.momentSelected = removeTime(scope.momentSelected|| moment());
                scope.month = scope.momentSelected.clone();
                scope.minDate = "2016-06-25";
                scope.maxDate = moment().format('YYYY-MM-DD');
                //scope.filleddates = ["2016-09-18", "2016-09-17", "2016-09-16", "2016-09-15", "2016-09-14", "2016-09-13"];
                var maxDate = moment(scope.maxDate);
                var minDate = moment(scope.minDate);
                minDate = removeTime(minDate);
                //var maxDate = removeTime(moment());
                maxDate = maxDate.hour(0).minute(0).second(0).millisecond(0);

                var start = scope.momentSelected.clone();
                start.date(1);
                removeTime(start.day(0));
                console.log(scope.filleddates);

                buildMonth(scope, start, scope.month, minDate, maxDate, scope.filleddates);

                scope.select = function(day) {
                    scope.selectedFormattedDate = day.formattedDate;
                    scope.selected = day.formattedDate; 
                };

                //scope.disableNext()

                scope.disableNext = false;
                scope.disablePrevious = false;

                if(scope.month.format("MMMM, YYYY") === moment().format("MMMM, YYYY")){
                    scope.disableNext = true;
                }

                if(minDate.format("MMMM, YYYY") === scope.month.format("MMMM, YYYY")){
                    scope.disablePrevious = true;
                }

                scope.dotsDisplay = function(status){
                    if(status && scope.showdots){
                        return true;
                    }
                    return false;
                };

                scope.next = function() {
                    scope.disablePrevious = false;
                    var next = scope.month.clone();
                    removeTime(next.month(next.month()+1).date(1));
                    scope.month.month(scope.month.month()+1);
                    if(scope.month.format("MMMM, YYYY") === moment().format("MMMM, YYYY")){
                        scope.disableNext = true;
                    }
                    buildMonth(scope, next, scope.month, minDate, maxDate, scope.filleddates);
                };

                scope.previous = function() {
                    scope.disableNext = false;
                    var previous = scope.month.clone();
                    removeTime(previous.month(previous.month()-1).date(1));
                    scope.month.month(scope.month.month()-1);
                    if(minDate.format("MMMM, YYYY") === scope.month.format("MMMM, YYYY")){
                        scope.disablePrevious = true;
                    }
                    buildMonth(scope, previous, scope.month, minDate, maxDate, scope.filleddates);
                };
            })
            
        }
    };
}

function removeTime(date) {
        return date.day(0).hour(0).minute(0).second(0).millisecond(0);
    }

    function buildMonth(scope, start, month, minDate, maxDate, filleddates) {
        scope.weeks = [];
        var done = false, date = start.clone(), monthIndex = date.month(), count = 0;
        while (!done) {
            scope.weeks.push({ days: buildWeek(date.clone(), month, minDate, maxDate, filleddates) });
            date.add(1, "w");
            done = count++ > 2 && monthIndex !== date.month();
            monthIndex = date.month();
        }
    }

    function buildWeek(date, month, minDate, maxDate, filleddates) {
        var days = [];
        for (var i = 0; i < 7; i++) {
            days.push({
                name: date.format("dd").substring(0, 1),
                number: date.date(),
                isCurrentMonth: date.month() === month.month(),
                isToday: date.isSame(new Date(), "day"),
                disable: ((date < minDate) || (date > maxDate)) ? true : false,
                isFilled: R.contains(date.format('YYYY-MM-DD'), filleddates),
                date: date,
                formattedDate: date.format('YYYY-MM-DD')
            });
            date = date.clone();
            date.add(1, "d");
            //console.log(days);
        }
        return days;
    }
    
    




/** WEBPACK FOOTER **
 ** ./src/olr-directives/calendarAttendance.js
 **/